import type { AppRouteRecordRaw } from '@/router/types';

import { PAGE_NOT_FOUND_NAME, LAYOUT, HidePageEnum } from '@/router/constant';

export const EXCEPTION_COMPONENT = () =>
    import('@/views/sys/exception.vue');

// 404 on a page
export const PAGE_NOT_FOUND_ROUTE: AppRouteRecordRaw = {
    path: '/',
    name: PAGE_NOT_FOUND_NAME,
    component: LAYOUT,
    meta: {
        title: 'ErrorPage',
        hideBreadcrumb: true,
        hideMenu: true,
    },
    children: [
        {
            path: '/:path(.*)*',
            name: PAGE_NOT_FOUND_NAME,
            component: EXCEPTION_COMPONENT,
            meta: {
                title: 'ErrorPage',
                hideBreadcrumb: true,
                hideMenu: true,
            },
        },
    ],
};

// SVG Preview
export const SVG_PREVIEW: AppRouteRecordRaw = {
    path: '/svg',
    name: HidePageEnum.SVGPreview,
    redirect: '/svg/display',
    component: () => import('@/views/sys/svg-preview.vue'),
    meta: {
        title: 'svg preview',
        hideBreadcrumb: true,
        hideMenu: true,
    },
    children: [
        {
            path: 'display',
            name: HidePageEnum.SVGPreviewDisplay,
            component: () => import('@/views/sys/svg-preview.vue'),
            meta: {
                title: 'svg preview',
                hideBreadcrumb: true,
            },
        },
    ],
};

// Model Preview
export const MODEL_PREVIEW: AppRouteRecordRaw = {
    path: '/model',
    name: HidePageEnum.ModelPreview,
    component: () => import('@/views/sys/model-preview.vue'),
    meta: {}
}